
export const INITIAL_STATE = Symbol('@redux/INITIAL_STATE');

export const createReducer = (handlers) => {
    function reducer(stateOrUndefined, action) {
        const initialState = handlers[INITIAL_STATE];
        const state = typeof stateOrUndefined === 'undefined' ? initialState : stateOrUndefined;

        const handler = handlers[action.type];
        const handlerArgs = [state, action];

        if (typeof handler === 'undefined') return state;
        if (typeof handler === 'function' || typeof handler === 'symbol') {
            return Reflect.apply(handler, null, handlerArgs);
        }

        throw new Error(`Unexpected handler type "${typeof handler}"`);
    }

    reducer.handlers = handlers;
    reducer.initialState = handlers[INITIAL_STATE];

    return reducer;
};
